<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        This activity is all about creating a scene using minimal dialogue. The great thing about
        acting is that you don’t always need dialogue in order to express emotion.
      </p>
      <p class="mb-5">
        You will need at least two other people as well as yourself for this activity. This task
        will help you learn to improvise and increase your confidence in creating a character with
        limited information.
      </p>
      <p class="mb-5">You will need:</p>
      <ol class="numbered-list">
        <li>Yourself plus <b>one</b> other person to act opposite you</li>
        <li><b>At least</b> one ‘audience’ member (more than one if possible)</li>
        <li>A piece of <b>paper</b> and <b>pen</b></li>
      </ol>

      <p class="mb-5">
        <b>Step 1:</b> Watch the video below containing scenes with minimal dialogue.
      </p>
      <div class="vx-row mt-10 mb-5">
        <div class="vx-col xl:w-2/3 w-full my-5">
          <responsive-iframe-youtube src="https://www.youtube.com/embed/F2bk_9T482g" />
        </div>
      </div>
      <p class="mb-5">
        <b>Step 2:</b> On a piece of paper, write down 3 things in total that the actors did that
        made it a believable performance (facial expressions, gestures or movement).
      </p>
      <p class="mb-5">1)</p>
      <p class="mb-5">2)</p>
      <p class="mb-5">3)</p>
      <p class="mb-5">
        <b>Step 3:</b> Next, write the four phrases below down on a new piece of paper. You will be
        using these phrases to try and create a performance using minimal dialogue.
      </p>
      <p class="mb-5">1. What do you mean?</p>
      <p class="mb-5">2. I love you</p>
      <p class="mb-5">3. You can’t be serious</p>
      <p class="mb-5">4. I’m sorry</p>
      <p class="mb-5">
        <b>Step 4:</b> Pick someone to get up “onstage” with you - onstage can be anywhere you want
        in your house, and you can choose a friend or family member to help you with the scene.
      </p>
      <p class="mb-5">
        <b>Step 5:</b> Have your audience sit opposite you ‘onstage’. Get suggestions from the
        ‘audience’ about your character's relationship, environment and what happened last time they
        saw each other.
      </p>
      <p class="mb-5">
        <b>Step 6:</b> Create a 5-minute long scene and tell a story using only the phrases from
        step 3 as your dialogue. Really focus on telling the story within the limits of the dialogue
        above using facial expressions, movements and gestures.
      </p>
      <h4 class="mb-5">Activity questions</h4>
      <p class="mb-5">Write down answers to the questions below.</p>
      <p class="mb-5">1. How did you find acting using limited phrases (hard, easy etc.)? Why?</p>
      <textarea-block v-model="data.question1" :editable="isEditable" />

      <p class="mb-5">2. What kind of movements, facial expressions or gestures did you use?</p>
      <textarea-block v-model="data.question2" :editable="isEditable" />

      <p class="mb-5">
        3. Name one way that you could use movements, gestures or facial expressions to show
        excitement without speaking.
      </p>
      <textarea-block v-model="data.question3" :editable="isEditable" />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
